<template>
  <button :class="$style['button']" :tabindex="tabIndex">
    <icon-close :class="$style['button__icon']" />
  </button>
</template>

<script setup lang="ts">
import IconClose from '@/components/icons/IconClose.vue'

withDefaults(
  defineProps<{
    tabIndex?: string | undefined
  }>(),
  {
    tabIndex: undefined,
  }
)
</script>

<style lang="scss" module>
.button {
  display: inline-flex;
  align-items: center;
  padding: 0.1em;
  border: 0;
  background-color: transparent;

  &:hover {
    cursor: pointer;
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }

  &__icon {
    color: inherit;
    font-size: inherit;
  }
}
</style>
